(function () {
  var root = document.querySelector('[data-aevp-root]');
  if (!root) return;

  var form = root.querySelector('[data-aevp-form]');
  var byoWrap = root.querySelector('[data-aevp-byo]');
  var errorEl = root.querySelector('[data-aevp-error]');
  var submitBtn = root.querySelector('[data-aevp-submit]');
  var klaviyoEl = root.querySelector('[data-aevp-klaviyo]');
  var klaviyoCfg = { publicKey: '', listId: '', phone: '07 5500 0095' };

  try {
    if (klaviyoEl) klaviyoCfg = JSON.parse(klaviyoEl.textContent);
  } catch (e) {
    /* keep defaults */
  }

  function setRadio(name, value) {
    var input = form && form.querySelector('input[name="' + name + '"][value="' + value + '"]');
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function scrollToForm() {
    var target = root.querySelector('#aevp-enquire');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function selectedPackage() {
    var input = form && form.querySelector('input[name="package"]:checked');
    return (input && input.value) || 'prospector';
  }

  function syncKits(value) {
    var pkg = value || 'prospector';
    if (pkg === 'not-sure') pkg = 'prospector';
    root.querySelectorAll('[data-aevp-kit]').forEach(function (el) {
      var on = el.getAttribute('data-aevp-kit') === pkg;
      el.hidden = !on;
      el.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    root.querySelectorAll('[data-aevp-package]').forEach(function (el) {
      el.classList.toggle('is-selected', el.getAttribute('data-aevp-package') === pkg);
    });
    root.querySelectorAll('[data-aevp-tab]').forEach(function (el) {
      var on = el.getAttribute('data-aevp-tab') === pkg;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-selected', on ? 'true' : 'false');
      el.tabIndex = on ? 0 : -1;
    });
    root.querySelectorAll('[data-aevp-col]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-aevp-col') === pkg);
    });
  }

  function syncModelOptions() {
    if (!form) return;
    var model = form.querySelector('#aevp-model');
    if (!model) return;
    var pkg = selectedPackage();
    var cab = pkg === 'cab-chassis';
    var current = model.value;
    var options = cab
      ? [
          { value: 'RAM 3500', label: 'RAM 3500' },
          { value: 'RAM 5500', label: 'RAM 5500' },
        ]
      : [
          { value: 'RAM 2500', label: 'RAM 2500' },
          { value: 'RAM 3500', label: 'RAM 3500' },
        ];
    model.innerHTML = '<option value="" selected disabled>Select</option>';
    options.forEach(function (opt) {
      var el = document.createElement('option');
      el.value = opt.value;
      el.textContent = opt.label;
      model.appendChild(el);
    });
    var stillValid = options.some(function (opt) {
      return opt.value === current;
    });
    if (stillValid) model.value = current;
  }

  function syncByo() {
    if (!form || !byoWrap) return;
    var intent = form.querySelector('input[name="inquiry_type"]:checked');
    var isByo = intent && intent.value === 'byo_truck';
    byoWrap.hidden = !isByo;
    byoWrap.querySelectorAll('input, select').forEach(function (el) {
      if (el.name === 'truck_colour' || el.name === 'vehicle_year' || el.name === 'vehicle_model') {
        el.required = isByo;
      }
    });
  }

  root.querySelectorAll('.aevp-path[data-aevp-intent]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-aevp-intent');
      root.querySelectorAll('.aevp-path[data-aevp-intent]').forEach(function (el) {
        el.classList.toggle('is-selected', el === btn);
      });
      setRadio('inquiry_type', value);
      scrollToForm();
    });
  });

  root.querySelectorAll('.aevp-hero [data-aevp-intent]').forEach(function (link) {
    link.addEventListener('click', function () {
      setRadio('inquiry_type', link.getAttribute('data-aevp-intent'));
    });
  });

  root.querySelectorAll('.aevp-pkg[data-aevp-package]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-aevp-package');
      setRadio('package', value);
      syncKits(value);
      var kit = root.querySelector('#aevp-package');
      if (kit) kit.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  root.querySelectorAll('[data-aevp-tab]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-aevp-tab');
      setRadio('package', value);
      syncKits(value);
    });
  });

  if (form) {
    form.querySelectorAll('input[name="inquiry_type"]').forEach(function (el) {
      el.addEventListener('change', syncByo);
    });
    form.querySelectorAll('input[name="package"]').forEach(function (el) {
      el.addEventListener('change', function () {
        var value = selectedPackage();
        syncKits(value);
        syncModelOptions();
      });
    });
    syncByo();
    syncKits(selectedPackage());
    syncModelOptions();
  }

  var subnavLinks = root.querySelectorAll('[data-aevp-subnav] a');
  if ('IntersectionObserver' in window && subnavLinks.length) {
    var sections = [];
    subnavLinks.forEach(function (link) {
      var id = (link.getAttribute('href') || '').replace('#', '');
      var section = id && document.getElementById(id);
      if (section) sections.push(section);
    });
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          subnavLinks.forEach(function (link) {
            link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
          });
        });
      },
      { rootMargin: '-40% 0px -50% 0px', threshold: 0 }
    );
    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  var lightboxRoot = root.querySelector('[data-aevp-lightbox-root]');
  var lightboxItems = Array.prototype.slice.call(root.querySelectorAll('[data-aevp-lightbox]'));
  var lightboxImg = root.querySelector('[data-aevp-lightbox-img]');
  var lightboxCaption = root.querySelector('[data-aevp-lightbox-caption]');
  var lightboxIndex = 0;

  function showLightbox(index) {
    if (!lightboxRoot || !lightboxItems.length) return;
    lightboxIndex = (index + lightboxItems.length) % lightboxItems.length;
    var item = lightboxItems[lightboxIndex];
    lightboxImg.src = item.getAttribute('data-aevp-src');
    lightboxImg.alt = item.getAttribute('data-aevp-alt') || '';
    lightboxCaption.textContent = item.getAttribute('data-aevp-alt') || '';
    lightboxRoot.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function hideLightbox() {
    if (!lightboxRoot) return;
    lightboxRoot.hidden = true;
    document.body.style.overflow = '';
  }

  lightboxItems.forEach(function (item, index) {
    item.addEventListener('click', function () {
      showLightbox(index);
    });
  });

  if (lightboxRoot) {
    var closeBtn = lightboxRoot.querySelector('[data-aevp-lightbox-close]');
    var prevBtn = lightboxRoot.querySelector('[data-aevp-lightbox-prev]');
    var nextBtn = lightboxRoot.querySelector('[data-aevp-lightbox-next]');
    if (closeBtn) closeBtn.addEventListener('click', hideLightbox);
    if (prevBtn) prevBtn.addEventListener('click', function () { showLightbox(lightboxIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showLightbox(lightboxIndex + 1); });
    lightboxRoot.addEventListener('click', function (e) {
      if (e.target === lightboxRoot) hideLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (lightboxRoot.hidden) return;
      if (e.key === 'Escape') hideLightbox();
      if (e.key === 'ArrowLeft') showLightbox(lightboxIndex - 1);
      if (e.key === 'ArrowRight') showLightbox(lightboxIndex + 1);
    });
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (errorEl) errorEl.hidden = true;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    if (!klaviyoCfg.publicKey || !klaviyoCfg.listId || String(klaviyoCfg.publicKey).indexOf('YOUR_') === 0) {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = 'Enquiry form is not configured yet. Call us on ' + (klaviyoCfg.phone || '07 5500 0095') + '.';
      }
      return;
    }

    var data = new FormData(form);
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting…';

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: data.get('form_source') || 'AEV Prospector',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: data.get('email'),
                first_name: (data.get('full_name') || '').split(' ')[0] || '',
                last_name: (data.get('full_name') || '').split(' ').slice(1).join(' ') || '',
                phone_number: data.get('phone'),
                properties: {
                  Form_Source: data.get('form_source') || 'AEV Prospector',
                  Inquiry_Type: data.get('inquiry_type') || '',
                  Package: data.get('package') || '',
                  Truck_Colour: data.get('truck_colour') || '',
                  Vehicle_Year: data.get('vehicle_year') || '',
                  Vehicle_Model: data.get('vehicle_model') || '',
                  Preferred_Workshop: data.get('preferred_workshop') || '',
                  Questions_Comments: data.get('questions_comments') || '',
                  Page_URL: window.location.href,
                },
              },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: klaviyoCfg.listId } },
        },
      },
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + klaviyoCfg.publicKey, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2023-12-15',
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (res.status === 202 || res.status === 200 || res.status === 204) {
          var pkgLabels = {
            prospector: 'an AEV Prospector',
            xl: 'an AEV Prospector XL',
            tray: 'an AEV Prospector XL Tray Bed',
            'cab-chassis': 'an AEV Prospector XL Cab Chassis',
            'not-sure': 'an AEV Prospector',
          };
          var pkg = data.get('package') || 'prospector';
          var intent =
            data.get('inquiry_type') === 'supply_truck'
              ? 'supplying a RAM and building ' + (pkgLabels[pkg] || 'an AEV Prospector')
              : 'fitting ' + (pkgLabels[pkg] || 'an AEV Prospector') + ' to your truck';
          form.innerHTML =
            '<div class="aevp-form__success">' +
            '<h2>Thank you</h2>' +
            '<p>Your enquiry about <strong>' +
            escapeHtml(intent) +
            '</strong> is in. Pricing is on application — the Tough Trucks team will be in touch shortly.</p>' +
            '</div>';
        } else {
          throw new Error(String(res.status));
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send enquiry';
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent =
            'There was an error submitting the form. Please try again or call us on ' +
            (klaviyoCfg.phone || '07 5500 0095') +
            '.';
        }
      });
  });
})();
